import { v4 as uuidv4 } from 'uuid';

export function ProductInstallmentsList(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductInstallmentsList',
		componentId: uuidv4(),
		title: '',
		props: Object.assign(
			{
				markers: [],
				blockClass: '',
				message: '',
				paymentSystemName: '',
				installmentsToShow: [],
			},
			props,
		),
		childrenComponents,
	};
}
